import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=162d3132&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=162d3132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d3132",
  null
  
)

export default component.exports